var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSortAsc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    enableBackground: "new 0 0 16 16",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sort_ascending"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8,7h3c0.55,0,1-0.45,1-1c0-0.55-0.45-1-1-1H8C7.45,5,7,5.45,7,6 C7,6.55,7.45,7,8,7z M8,3h1c0.55,0,1-0.45,1-1c0-0.55-0.45-1-1-1H8C7.45,1,7,1.45,7,2C7,2.55,7.45,3,8,3z M8,11h5 c0.55,0,1-0.45,1-1c0-0.55-0.45-1-1-1H8c-0.55,0-1,0.45-1,1C7,10.55,7.45,11,8,11z M5,12c-0.28,0-0.53,0.11-0.71,0.29L4,12.59V9 c0-0.55-0.45-1-1-1S2,8.45,2,9v3.59l-0.29-0.29C1.53,12.11,1.28,12,1,12c-0.55,0-1,0.45-1,1c0,0.28,0.11,0.53,0.29,0.71l2,2 C2.47,15.89,2.72,16,3,16s0.53-0.11,0.71-0.29l2-2C5.89,13.53,6,13.28,6,13C6,12.45,5.55,12,5,12z M15,13H8c-0.55,0-1,0.45-1,1 c0,0.55,0.45,1,1,1h7c0.55,0,1-0.45,1-1C16,13.45,15.55,13,15,13z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortAsc);
export default __webpack_public_path__ + "static/media/sort-asc.4afef34c46db56d86a758b98f956b333.svg";
export { ForwardRef as ReactComponent };